import { render, staticRenderFns } from "./TurnstileWidget.vue?vue&type=template&id=3bee4b0e&scoped=true"
import script from "./TurnstileWidget.vue?vue&type=script&lang=js"
export * from "./TurnstileWidget.vue?vue&type=script&lang=js"
import style0 from "./TurnstileWidget.vue?vue&type=style&index=0&id=3bee4b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bee4b0e",
  null
  
)

export default component.exports